import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/tenda-matese.png")